import React from 'react';

const HandoverChecklist = ({ received, inspected, responsible, onReceivedChange, onInspectedChange, onResponsibleChange }) => {
  return (
    <div className="handover-checklist">
      <h3 style={{ margin: '0 0 12px 0', fontSize: '14px', fontWeight: 600, color: '#2d3748' }}>
        Confirm Receipt
      </h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          cursor: 'pointer',
          padding: '10px',
          background: received ? '#c6f6d5' : '#f7fafc',
          border: `2px solid ${received ? '#38a169' : '#e2e8f0'}`,
          borderRadius: '6px',
          transition: 'all 0.2s'
        }}>
          <input
            type="checkbox"
            checked={received}
            onChange={(e) => onReceivedChange && onReceivedChange(e.target.checked)}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer'
            }}
          />
          <span style={{ fontSize: '13px', fontWeight: 500, color: received ? '#22543d' : '#4a5568' }}>
            I have physically received all the selected assets.
          </span>
        </label>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer',
          padding: '10px',
          background: inspected ? '#c6f6d5' : '#f7fafc',
          border: `2px solid ${inspected ? '#38a169' : '#e2e8f0'}`,
          borderRadius: '6px',
          transition: 'all 0.2s'
        }}>
          <input
            type="checkbox"
            checked={inspected}
            onChange={(e) => onInspectedChange && onInspectedChange(e.target.checked)}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer'
            }}
          />
          <span style={{ fontSize: '13px', fontWeight: 500, color: inspected ? '#22543d' : '#4a5568' }}>
            I have inspected the condition of the assets.
          </span>
        </label>
        <label style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer',
          padding: '10px',
          background: responsible ? '#c6f6d5' : '#f7fafc',
          border: `2px solid ${responsible ? '#38a169' : '#e2e8f0'}`,
          borderRadius: '6px',
          transition: 'all 0.2s'
        }}>
          <input
            type="checkbox"
            checked={responsible}
            onChange={(e) => onResponsibleChange && onResponsibleChange(e.target.checked)}
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer'
            }}
          />
          <span style={{ fontSize: '13px', fontWeight: 500, color: responsible ? '#22543d' : '#4a5568' }}>
            I agree that these assets are under my responsibility.
          </span>
        </label>
      </div>
    </div>
  );
};

export default HandoverChecklist;


